import { cn, useTranslation } from '@/core'
import { FeatureCard } from '@/ui'

interface FeaturesSectionProps {
  className?: string
}

export function FeaturesSection({ className }: FeaturesSectionProps) {
  const { t } = useTranslation()

  const features = [
    {
      title: t('dashboard.features.bookingManagement.title'),
      description: t('dashboard.features.bookingManagement.description'),
      icon: 'calendar',
    },
    {
      title: t('dashboard.features.dailySummary.title'),
      description: t('dashboard.features.dailySummary.description'),
      icon: 'bar-chart',
    },
    {
      title: t('dashboard.features.weeklyPlanning.title'),
      description: t('dashboard.features.weeklyPlanning.description'),
      icon: 'clock',
    },
    {
      title: t('dashboard.features.userManagement.title'),
      description: t('dashboard.features.userManagement.description'),
      icon: 'users',
    },
    {
      title: t('dashboard.features.googleCalendar.title'),
      description: t('dashboard.features.googleCalendar.description'),
      icon: 'bell',
    },
    {
      title: t('dashboard.features.excelExport.title'),
      description: t('dashboard.features.excelExport.description'),
      icon: 'file-down',
    },
  ]

  return (
    <section id="features" className={cn('py-16 sm:py-20 lg:py-24', className)}>
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-12 text-center">
          <h2 className="mb-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">
            {t('landing.features.title')}
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-gray-600">
            {t('landing.features.subtitle')}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {features.map((feature) => (
            <FeatureCard key={feature.title} {...feature} />
          ))}
        </div>
      </div>
    </section>
  )
}
